import React, { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'
import ReactSelectCreatableSelect from 'react-select/creatable'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import { Button, Flex } from '@chakra-ui/react'

const CreatableSelect = ({
  name,
  defaultOptions = [],
  isRequired = true,
  isClearable = false,
  disabled,
  isMulti = true,
  placeholder = 'Select / type to create...',
  containerWidth = '100%',
  ...rest
}) => {
  const handleFocus = (name) => {
    const errorElement = document.getElementById(name)
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        const [options, setOptions] = useState(value.map((v) => ({ label: v, value: v })))
        const [selectedOption, setSelectedOption] = useState(value.map((v) => ({ label: v, value: v })))

        const handleCreate = (newValue) => {
          setOptions((prev) => [...prev, { label: newValue, value: newValue }])
          setSelectedOption((prev) => [...prev, { label: newValue, value: newValue }])
          onChange([...value, newValue])
        }

        const handleOnChange = (newValue) => {
          setSelectedOption(newValue)
          onChange(newValue.map((v) => v.value))
        }
        return (
          <FieldWrapper name={name} error={error} isRequired={isRequired} {...rest}>
            <Flex gap={2} w="100%" alignItems="center">
              <ReactSelectCreatableSelect
                isClearable={isClearable}
                isMulti={true}
                styles={{
                  container: () => ({ flex: 1 }),
                  control: (base, { isDisabled }) => {
                    let bgColor = 'white'
                    if ((value === '' || value?.length === 0) && isRequired) {
                      bgColor = 'yellow'
                    }
                    if (isDisabled) {
                      bgColor = 'hsl(0, 0%, 95%)'
                    }
                    return { ...base, borderColor: '#E2E8F0', backgroundColor: bgColor, width: containerWidth }
                  },
                  singleValue: (base) => ({ ...base, color: 'hsl(0, 0%, 50%)' }),
                  multiValueRemove: (base, state) => (state.isDisabled ? { ...base, display: 'none' } : base),
                }}
                classNamePrefix="custom-select"
                options={options}
                value={selectedOption}
                onChange={handleOnChange}
                onCreateOption={handleCreate}
                onFocus={() => handleFocus(name)}
                onBlur={onBlur}
                isDisabled={disabled}
                menuPortalTarget={document.body}
                placeholder={placeholder}
              />
            </Flex>
          </FieldWrapper>
        )
      }}
    />
  )
}

export default CreatableSelect
